import React, { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { IoMdAdd } from "react-icons/io";

import { CustomCheckbox, ModalContainer, SelectAddressModalContainer } from "../styled";

import { useRegex } from "../../../../../hooks/useRegex";
import useGlobalScroll from "../../../../../hooks/useGlobalScroll";
import SectionHeader from "../../common/sectionTitle";

const SelectAddressModal = ({ toggleModal, addresses, selected, setSelected }) => {
  const { TelFormat } = useRegex();
  useGlobalScroll();

  const [checked, setChecked] = useState(null);

  useEffect(() => {
    setChecked({ ...selected });
  }, [selected]);

  return (
    <ModalContainer onClick={(e) => e.target === e.currentTarget && toggleModal()}>
      <SelectAddressModalContainer>
        <div className="modal">
          <div className="form">
            <SectionHeader
              title={`배송지 변경`}
              subtitle={{
                icon: IoMdAdd,
                label: "배송지 추가",
                clickEvent: () => toggleModal(null, "form"),
              }}
              action={{
                icon: AiOutlineClose,
                className: "close",
                clickEvent: () => toggleModal(),
              }}
            />
            <ul>
              {addresses.map((item) => (
                <li>
                  <div className="info">
                    <CustomCheckbox>
                      <input
                        type="checkbox"
                        checked={checked && item.id === checked.id}
                        onChange={() => setChecked(item)}
                      />
                      <span></span>
                    </CustomCheckbox>
                    <strong>{item.nickname}</strong>
                  </div>
                  <p>
                    <span>
                      ({item.postcode}) {item.address}
                      {item.detailAddress && ` ${item.detailAddress}`}
                    </span>
                    <span>{TelFormat(item.phone)}</span>
                  </p>
                  <button onClick={() => toggleModal(item, "form")}>수정</button>
                </li>
              ))}
            </ul>
          </div>
          <button
            className="submit"
            onClick={() => {
              setSelected(checked);
              toggleModal();
            }}>
            확인
          </button>
        </div>
      </SelectAddressModalContainer>
    </ModalContainer>
  );
};

export default SelectAddressModal;
